import { Helmet } from "react-helmet";

function CalculatorHead() {
  return (
    <Helmet>
      <title>Sera - Debt Payoff Calculator</title>
      <meta name="title" content="Credit Card Debt Savings Calculator" />
      <meta name="description" content="Sera's credit card debt payoff calculator enables you to see how much time and money you can save by using our tools to eliminate your debt." />
      <meta name="keywords" content="credit card debt, debt calculator, financial freedom, debt reduction, debt elimination, investing, debt free, asset growth, asset acceleration, passive income, financial wellness, financial health, retire early, investments" />
      <meta name="robots" content="index, follow" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="language" content="English" />
      <meta name="author" content="Sera, LLC" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="2 days" />
      <meta name="author" content="Sera, LLC" />
    </Helmet>
  );
}
export default CalculatorHead;